interface ExtjsConfig {
  url: string;
}

// DEV-Umgebung: Muss mit Proxy synchronisiert werden
export const EXTJS_CONFIG: ExtjsConfig = {
  url: "extjs/"
};
